import React from 'react';
import { connect } from 'react-redux';
import { IPage, IUser } from '@whitelabel/helpers/types';
import { FooterLarge, FooterSlim } from '../../../components/Footer';
import { useGetDisclaimerQuery } from '../../../store/services/xcover/endpoints/pages';

interface IFooterProps {
  footertype?: 'slim' | 'large';
  locale: string;
  user?: IUser;
  disclaimer?: IPage;
  disclaimerSlug?: string;
  hidedisclaimer?: 'true' | 'false';
  hidefooternav?: 'true' | 'false';
}

const Footer = ({
  footertype = 'large',
  locale,
  user,
  disclaimer,
  disclaimerSlug = 'disclaimer',
  hidedisclaimer = 'false',
  hidefooternav,
}: IFooterProps) => {
  const { data } = useGetDisclaimerQuery(
    { locale, slug: disclaimerSlug },
    {
      skip: footertype !== 'large' || !!disclaimer || hidedisclaimer !== 'false',
    },
  );
  const disclaimerContent = hidedisclaimer === 'true' ? undefined : disclaimer || data;

  return footertype === 'slim' ? (
    <FooterSlim />
  ) : (
    <FooterLarge disclaimer={disclaimerContent} user={user} hideFooterNav={hidefooternav === 'true'} />
  );
};

const mapStateToProps = (state: any) => {
  const { locale } = state.intl;

  return {
    locale,
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(Footer);
